module.exports = __webpack_public_path__ + "assets/roboto-v30-latin_latin-ext-700.52ab1ba80e525b22e7e4498c3482f755.woff";